import { useEffect, useState } from 'react';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSivCheckListView } from './useSivCheckListView';
import VersionHistory from 'src/components/common/VersionHistory';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { DataTable } from '@pihealth/common-ui-library';
import { setSelectedRowData, setChckListCMPArr } from 'src/store/sivCheckList';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import staticData from '../../../resources/static.json';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';

//import { Link } from 'react-router-dom';

export default function SivChecklistListView() {
  const { userPreferedDateFormat, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [headerTitle, setHedertitle] = useState('');
  const [docId, setDocId] = useState('');
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const [rows, setRows] = useState<any>([]);
  const dispatch = useAppDispatch();
  const { selectedAppSection } = useSelectedAppInfo();
  const {
    getAllsivChecklistData,
    getAllsivChecklistIsError,
    getAllsivChecklistIsLoading,
    getAllsivChecklistIsSuccess,
    getAllSIVChecklists
  } = useSivCheckListView();

  useEffect(() => {
    getAllSIVChecklists({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      application_section: selectedAppSection,
      application_module_section: 'SIV CHECKLIST'
    });
  }, [selectedCountry, studyId, selectedSite]);

  useEffect(() => {
    if (getAllsivChecklistIsSuccess) {
      if (getAllsivChecklistData && Array.isArray(getAllsivChecklistData)) {
        setRows(
          getAllsivChecklistData.map((item: any) => {
            return {
              ...item,
              updated_on: getPreferredDateTimeInLocal(item.updated_on),
              start_date: getPreferredDateTimeInLocal(item.start_date),
              major_version: Number(item.major_version).toFixed(1).toString()
            };
          })
        );
      }
    }
  }, [getAllsivChecklistIsError, getAllsivChecklistIsSuccess, getAllsivChecklistIsLoading]);

  const rowClick = (rowData: any) => {
    dispatch(setSelectedRowData(rowData));
    dispatch(setChckListCMPArr('sivchecklistpage'));
  };
  const versionClick = (versionData: any) => {
    setHedertitle(versionData.visit_name);
    setDocId(versionData.tp_document_id);
    setShowVersionHistory(true);
  };
  const actions = {
    visit_name: (data: any) => {
      rowClick(data);
    },
    major_version: (data: any) => {
      versionClick(data);
    }
  };

  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${staticData.sivChecklistView.file_export_name} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  return (
    <>
      <DataTable
        rows={rows}
        columns={staticData.sivChecklistView.dataTablecolumns}
        datePreference={userPreferedDateFormat}
        actions={actions}
        //loading={getAllsivChecklistIsLoading}
        showDateAndTime
        hasDefinedDataGridToolbarExport
        definedGridToolbarExport={definedCustomDatGridExport}
      />
      {showVersionHistory ? (
        <VersionHistory
          openVersoinHistory={showVersionHistory}
          setOpenVersoinHistory={setShowVersionHistory}
          title={headerTitle}
          documentId={docId}
          auditModuleSection={'SIV Checklist'}
        />
      ) : (
        ''
      )}
    </>
  );
}
